module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?e55a20c80650829ec5fdd868e583f64b";